import { Router } from '@angular/router';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DataService } from '../../shared/services/data.service';
import { KlaHttpService } from '../../shared/tools/services/kla.http.service';
import { CommonModule } from '@angular/common';

declare var gtag;

@Component({
  selector: 'kla-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class AnalyticsComponent implements OnInit, AfterViewInit {

  measurementId: string;
  private isAnalyticsActive = true;

  constructor(
    private httpService: KlaHttpService,
    private router: Router
  ) {
    this.measurementId = DataService.analyticsMeasurementId;
    if (window.opener) {
      window.opener.postMessage('started', '*');
      window.addEventListener('message', ($event) => {
        if (($event.origin.includes('localhost') || $event.origin.includes('admin-kla-')) && !$event.data.type) {
          this.measurementId = DataService.analyticsMeasurementId;
         // this.embedAnalyticsScripts();
        }
      });
    }
  }
  get isPreview () {
    let currentUrl = (window.location.href).toLocaleLowerCase();
    if(currentUrl.includes('preview')) {
      return true
    } else {
      return  false;
    }
  }

  get isTestSite() {
    let currentUrl = (window.location.href).toLocaleLowerCase();
    if(currentUrl.includes('2ambh')) {
      return true
    } else {
      return  false;
    }
  }

  ngOnInit(): void {
    const id = DataService.getData().website_id;
    this.httpService.checkIsAnalyticsActive(id).subscribe((response) => {
      this.isAnalyticsActive =  !!response.is_analytics_active;
      this.measurementId = response.analytics_measurement_id;
     // this.embedAnalyticsScripts();
    });
  }

  listenForClicks() {
    window.addEventListener('click', ($event) => {
      const target = $event.target;
      // @ts-ignore
      if (target.tagName.toLowerCase() === 'a') {
        // @ts-ignore
        gtag('event', 'link_click', {link_text: target.href});
      }
    });
  }

  ngAfterViewInit(): void {
    this.listenForClicks();
  }

  embedAnalyticsScripts() {
    if (this.measurementId && this.isAnalyticsActive && !this.isPreview && !this.isTestSite) {
      const scriptElement = document.createElement('script');
      scriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
      const el = document.createElement('script');
      el.innerHTML = `window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${this.measurementId}');`;
      document.head.appendChild(scriptElement);
      document.head.appendChild(el);
    }
  }

}
